module.exports = __webpack_public_path__ + "static/media/confirmed_active.495dd8bb.svg";